const $ = require('jquery')
const partTypesQueryKeyName = 'selected_part_type_urls[]'

function buildURL (prefecture, city, partType) {
  let url = ''
  if (!prefecture && !city && partType) {
    url = 'part/' + partType + '/'
  }
  else if (prefecture && !city && !partType) {
    url = 'area/' + prefecture + '/'
  }
  else if (prefecture && !city && partType) {
    url = 'area/' + prefecture + '/part/' + partType + '/'
  }
  else if (prefecture && city && !partType) {
    url = 'area/' + prefecture + '/' + city + '/'
  }
  else if (prefecture && city && partType) {
    url = 'area/' + prefecture + '/' + city + '/' + partType + '/'
  }

  return location.origin + '/' + url + 'review'
}

function buildParams (partTypes) {
  let params = '?'
  $.each(partTypes, function (i, partType) {
    if (i !== 0) {
      params += '&'
    }
    params += partTypesQueryKeyName + '=' + partType
  })
  return params
}

$(function () {
  $('.js-redirect-by-params').submit(function (e) {
    e.preventDefault()
    const prefecture = $('#selected_prefecture_name').val()
    const city = $('#selected_city_id').val()
    // target経由でないとpc版とsp版の両方からデータ取得をしてしまう
    const partTypes = $(e.target).find(`input:checkbox[name="${partTypesQueryKeyName}"]:checked`).map(function () {
      return $(this).val()
    }).get()

    // 現状、単一の部位ページしかルーティングがないため、複数の部位がある場合はパラメータで制御する
    if (partTypes.length <= 1) {
      location.href = buildURL(prefecture, city, partTypes[0])
    }
    else {
      location.href = buildURL(prefecture, city) + buildParams(partTypes)
    }
  })
})
